import React from 'react';

const SvgPositiveEvolution = (props) => (
  <svg width={8} height={8} {...props}>
    <path
      fill="#6CC89F"
      fillRule="evenodd"
      stroke="#6CC89F"
      strokeWidth={0.5}
      d="M.593 6.78l5.493-5.39h-3.18V.8h4.205v4.127h-.6v-3.12L1.014 7.2z"
    />
  </svg>
);

export default SvgPositiveEvolution;
